import React, { useState } from 'react';
import { SORT } from '../../constans/constans';

const TableHeaderElement = ({ params }) => {
  const [sortAscDesc, setSortAscDesc] = useState(SORT.ASC);
  const { projectDataSort, sortName, value } = params;

  return (
    <div
      className={!sortName ? 'sort__block' : 'sort__block sort__pointer'}
      onClick={() => {
        if (sortName) {
          projectDataSort(sortName, sortAscDesc);
          setSortAscDesc(sortAscDesc === SORT.ASC ? SORT.DESC : SORT.ASC);
        }
      }}
    >
      <span className="value">{value}</span>
      {sortName ? <i className={`icon-filter-arrow-${sortAscDesc === SORT.ASC ? 'up' : 'down'}`} /> : null}
    </div>
  );
};

export default TableHeaderElement;
